export default __webpack_public_path__ + "static/media/Pistol_3.3f65db2a.png";